<template>
  <div class="chatsBox">
    <div class="title">
      <h2>快捷对话</h2>
    </div>
    <div class="search">
      <el-input placeholder="请输入内容" v-model="keyword" :class="['searchInput', isDark ? 'darkInput' : '']" @change="GetTalkList">
        <div slot="suffix" class="searchIcon">
          <i class="el-icon-search"></i>
        </div> 
      </el-input>
    </div>
    <div class="talksBox scrollStyle">
      <template v-if="chatList.length">
      
      <div v-for="(item, index) in chatList" :key="item.aiAssistantId">
      <!-- <div v-for="(item, index) in chatList" :key="item.aiAssistantId" @click="goGpt(item)"> -->
        <Msg 
          :news="item" 
          :isHoverAction="true" 
          :isShowDialog="false"
          msgType="chat"
          @show="goGpt(item)" 
          @del="delChat(item)"
        >
        </Msg>
      </div>
    </template>
    <el-empty v-else description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import Msg from '../+components/Msg';
import {mapState, mapMutations, mapGetters} from 'vuex';

export default {
  name: 'Chats',
  components: {Msg},
  props: {},
  data () {
    return {
      GetAiassistantuserList: api.GetAiassistantuserList,
      DelByAIAssistantId: api.DelByAIAssistantId,
      chatList: [],
      keyword: '',
    }
  },
  computed: {
    ...mapState('userAbout', ['user']),
    ...mapState('comAbout', ['isDark']),
    // ...mapGetters('comAbout', ['menusBackground']),
  },
  watch: {},
  created () {},
  mounted () {
    this.GetTalkList();
  },
  methods: {
    ...mapMutations('userAbout', ['changeAiAssistantId', 'changeAiAssistant']),
    // 搜索列表
    // searchList() {
    //   console.log('搜索');
    // },
    // 删除对话
    delChat(item) {
      // console.log(item, '删除');
      this.$confirm("删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: this.isDark ? 'darkMessage' : '',
      }).then(() => {
        this.DelByAIAssistantId({ id: item.aiAssistantId })
          .then((res) => {
            if (res.success) {
              this.$message({
                message: `已删除`,
                type: "success",
              });
              this.GetTalkList();
            } else {
              this.$message.error("删除失败：" + res.message);
            }
          })
      })
    },
    // 获取快捷对话列表
    GetTalkList(keyword) {
      console.log('key', keyword);
      // const keyword = keyWord || undefined;
      const params = {
        sessionKey: this.user.session,
        keyword: keyword || undefined
      };
      this.GetAiassistantuserList(params).then((res) => {
        // console.log(res);
        this.chatList = res.data?.map(item => {
          return { 
            ...item, 
            avatar: item.assistantAvatarFileUrl,
            textTitle: item.assistantName,
            textContent: item.input,
            timeText: item.conversationTime,
            // timeText: item.timeText,
          }
        });
      })
    },
    // 移动端展开聊天页面
    goGpt(item) {
      // console.log(item, window.innerWidth);
      this.$emit('goChat');
      this.changeAiAssistantId(item.aiAssistantId);
      this.changeAiAssistant(item);
    }
  }
}
</script>

<style scoped lang="less">
.chatsBox {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    h2 {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .search {
    margin: 4px 0 16px;
    height: 55px;
    // :global(.el-input__inner) {
    //   background-color: #ebeff4;
    //   border: 0;
    //   border-radius: 8px;
    //   height: 55px;
    //   line-height: 55px;
    //   font-size: 13px;
    //   padding: 0 20px;
    // }
    .searchIcon {
      height: 55px;
      width: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 20px;
      }
    }
  }
  .talksBox {
    height: calc(100% - 22px - 55px);
    flex: 1;
    overflow-y: auto;
    padding-right: 3px;
    position: relative;

    /* 针对整个滚动条 */ 
    // &::-webkit-scrollbar {  
    //   width: 3px; /* 滚动条的宽度 */  
    // }
    // /* 滚动条轨道 */  
    // &::-webkit-scrollbar-track {  
    //   // background: #f1f7fe; /* 滚动条轨道的背景色 */  
    //   background: transparent;
    // } 
    // /* 滚动条滑块 */  
    // &::-webkit-scrollbar-thumb {  
    //   // background: #f1f7fe; /* 滚动条滑块的颜色 */  
    //   background: transparent;
    //   border-radius: 5px; /* 滑块边缘的圆角 */  
    // }  
    // &:hover::-webkit-scrollbar-thumb {
    //   background: rgb(238, 238, 238); 
    // }
  }

}
// .dark {
//   .search {
//     :global(.el-input__inner) {
//       background: #293145;
//     }
//   }
// }
</style>

<style lang="less">
.searchInput {
  width: 100%;
  .el-input__inner {
    background-color: #ebeff4;
    border: 0;
    border-radius: 8px;
    height: 55px;
    line-height: 55px;
    font-size: 13px;
    padding: 0 20px;
  }
  .el-input__inner:focus {
    box-shadow: 0 0 0 3.2px rgba(0, 123, 255, .25);
  }
  .el-textarea__inner {
    background-color: #ebeff4;
    border: 0;
    border-radius: 8px;
    font-size: 13px;
    padding: 16px 20px;

    &:focus {
      box-shadow: 0 0 0 3.2px rgba(0, 123, 255, .25);
    }
  }
}
.darkInput {
  .el-input__inner {
    background-color: #293145;
    color: #ddd;
  }
}
// 滚动条样式
.scrollStyle {
  /* 针对整个滚动条 */
  &::-webkit-scrollbar {
    width: 3px;
    /* 滚动条的宽度 */
  }

  /* 滚动条轨道 */
  &::-webkit-scrollbar-track {
    // background: #f1f7fe; /* 滚动条轨道的背景色 */  
    background: transparent;
  }

  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    // background: #f1f7fe; /* 滚动条滑块的颜色 */  
    background: transparent;
    border-radius: 5px;
    /* 滑块边缘的圆角 */
  }

  &:hover::-webkit-scrollbar-thumb {
    background: rgb(238, 238, 238);
  }
}
// .el-input.is-disabled.darkInput .el-input__inner{
//   background-color: #293145;
//   color: #ddd;
// }
</style>